// extracted by mini-css-extract-plugin
export default {"option":"styles_option__q4rVP","label":"styles_label__yC786"};